/**
 * CTS-9526: soft load balancing for candidate coach lists.
 *
 * When at least one coach with status === 'chat' has no active text chat,
 * only those fully available coaches are returned. If every chat-status
 * coach is already in a text chat, all of them are returned (fallback so
 * candidates can still open additional concurrent chats).
 *
 * Coaches in A/V (or at text capacity) use presence.show === 'dnd' and are
 * filtered out before this util runs — they are unaffected.
 *
 * Missing activeTextChatCount is treated as 0 (fully available) for rollout
 * compatibility with older coach clients.
 *
 * @param {Object} coach
 * @returns {boolean}
 */
export function isCoachFullyAvailable(coach) {
  return (coach?.activeTextChatCount ?? 0) === 0
}

/**
 * @param {Array<Object>} chatStatusCoaches - Coaches already filtered to status === 'chat'
 * @returns {Array<Object>}
 */
export function applyCoachLoadBalancing(chatStatusCoaches) {
  if (!chatStatusCoaches || chatStatusCoaches.length === 0) {
    return chatStatusCoaches || []
  }

  const fullyAvailable = chatStatusCoaches.filter(isCoachFullyAvailable)
  return fullyAvailable.length > 0 ? fullyAvailable : chatStatusCoaches
}
